<div class="container">
  <div class="tabs-container">
    <button
      type="button"
      class="dap-available-tab tab"
      [ngClass]="{ 'active-tab': currentTab === 'available' }"
      [attr.aria-label]="'available' | translate"
      (click)="filterByTab('available')"
    >
      {{ 'available' | translate }}
    </button>
    <hr class="separator" />
    <button
      type="button"
      class="dap-completed-tab tab"
      [ngClass]="{ 'active-tab': currentTab === 'completed' }"
      [attr.aria-label]="'completed' | translate"
      (click)="filterByTab('completed')"
    >
      {{ 'completed' | translate }}
    </button>
    <hr class="separator" />
    <button
      class="dap-checked-out-tab tab"
      type="button"
      [ngClass]="{ 'active-tab': currentTab === 'checked_out' }"
      [attr.aria-label]="'checkedOut' | translate"
      (click)="filterByTab('checked_out')"
    >
      {{ 'checkedOut' | translate }}
    </button>
    <div class="tabs-right">
      @if (isSelectionEnabled && selectedBatches.length) {
        <span
          class="delete-batches-wrapper"
          tooltipPosition="bottom"
          [pTooltip]="canDeleteSelected ? '' : ('batchTable.deleteNoPermission' | translate)"
        >
          <p-button
            class="dap-delete-batches"
            icon="fa-solid fa-trash"
            size="small"
            severity="danger"
            [disabled]="!canDeleteSelected || isDeleting()"
            [attr.aria-label]="'batchTable.deleteSelected' | translate"
            (click)="confirmDeleteSelected()"
          >
          </p-button>
        </span>
      }
      <ng-content select="[createBatchButton]"></ng-content>
    </div>
  </div>

  <div
    #tableContainer
    class="table-container"
  >
    <p-table
      #dt
      sortMode="multiple"
      scrollHeight="flex"
      class="batch-table"
      [value]="batches"
      [columns]="cols"
      [scrollable]="true"
      [resizableColumns]="true"
      [multiSortMeta]="initialSort"
      [dataKey]="'batchId'"
      [(selection)]="selectedBatches"
    >
      <ng-template pTemplate="header">
        <tr>
          @if (isSelectionEnabled) {
            <th
              class="non-sortable selection-column"
              pResizableColumn
            >
              <span class="sr-only">{{ 'batchTable.selectAllBatches' | translate }}</span>
              <p-tableHeaderCheckbox [ariaLabel]="'batchTable.selectAllBatches' | translate" />
            </th>
          }
          @for (col of cols; track col.field) {
            @if (col.allowSort) {
              <th
                pSortableColumn="{{ col.field }}"
                pResizableColumn
              >
                {{ col.header | translate }}
                <span class="custom-sort-icon">
                  @if (getSortIconClass(col.field); as icon) {
                    <i
                      class="sort-icon fa-duotone fa-solid {{ icon }}"
                      aria-hidden="true"
                    ></i>
                  }
                </span>
              </th>
            } @else {
              <th
                pResizableColumn
                class="non-sortable"
              >
                {{ col.header | translate }}
              </th>
            }
          }
          @if (currentTab === 'checked_out') {
            <th
              pResizableColumn
              class="non-sortable"
            >
              <span class="sr-only">{{ 'batchTable.checkInBatch' | translate }}</span>
            </th>
          }
        </tr>
      </ng-template>

      <ng-template
        let-batch
        let-i="rowIndex"
        pTemplate="body"
      >
        <tr
          class="batch-row"
          [class.expiration-bg-warning]="isExpiringSoon(batch)"
          [class.row-disabled]="!canOpenBatch(batch)"
        >
          @if (isSelectionEnabled) {
            <td class="selection-column">
              <p-tableCheckbox
                [value]="batch"
                [ariaLabel]="'batchTable.selectBatch' | translate"
              />
            </td>
          }
          @for (col of cols; track col.field) {
            <td>
              @if (col.field === 'batchId') {
                <a
                  class="dap-open-batch batch-id"
                  [ngClass]="{ disabled: !canOpenBatch(batch) }"
                  [attr.tabindex]="canOpenBatch(batch) ? 0 : null"
                  [attr.href]="canOpenBatch(batch) ? getBatchUrl(batch) : null"
                  (click)="openBatch($event, batch)"
                  (keyup.enter)="openBatch($event, batch)"
                >
                  {{ col.value(batch) }}
                </a>
              } @else if (col.field === 'documentsExpiring') {
                <app-document-expiration-warning
                  [expirationDate]="batch.statistics?.earliestExpirationDate"
                />
                {{ col.value(batch) }}
              } @else {
                {{ col.value(batch) }}
              }
            </td>
          }
          @if (currentTab === 'checked_out') {
            <td>
              @if (canCheckInBatch(batch)) {
                <p-button
                  class="dap-check-in-batch settings-button"
                  variant="outlined"
                  size="small"
                  [label]="'checkIn' | translate"
                  [attr.aria-label]="'open' | translate"
                  (click)="checkInBatch(batch.batchId ?? '')"
                >
                </p-button>
              }
            </td>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td
            class="text-center"
            [attr.colspan]="
              cols.length + (currentTab === 'checked_out' || isSelectionEnabled ? 1 : 0)
            "
          >
            @if (isLoading) {
              <div
                class="flex justify-content-center align-items-center p-4 gap-2 loading-batches"
                role="status"
                aria-live="polite"
              >
                <i
                  class="fa-solid fa-spinner fa-pulse small-spinner"
                  aria-hidden="true"
                ></i>
                <span class="loading-message">{{ 'batchTable.loadingBatches' | translate }}</span>
              </div>
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
